import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { EmployeeDto, EmployeeModel } from "@core/models/employee.model";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

export interface EmployeeSaveResponse {
  id?: string;
  employeeId?: string;
  code?: number | string;
  status?: number | string;
  statusCode?: number | string;
  message?: string;
  detail?: string;
  success?: boolean;
}

export type EmployeeApiResponse = EmployeeSaveResponse | string | number | null;

@Injectable({
  providedIn: "root",
})
export class EmployeesService {
  constructor(private readonly http: HttpClient) {}

  getEmployees$(): Observable<EmployeeModel[]> {
    return this.http.get<EmployeeModel[]>(`${environment.BASE_URL}employee`);
  }

  saveEmployee$(
    data: Omit<EmployeeDto, "version">
  ): Observable<EmployeeApiResponse> {
    const lastNamePrefix =
      typeof data.lastNamePrefix === "string"
        ? data.lastNamePrefix.trim()
        : null;

    const body: Omit<EmployeeDto, "version"> = {
      ...data,
      firstName: data.firstName.trim(),
      lastName: data.lastName.trim(),
      phoneNumber: data.phoneNumber.trim(),
      email: data.email.trim().toLowerCase(),
      userName: data.userName.trim().toLowerCase(),
      lastNamePrefix: lastNamePrefix || null,
    };

    return this.http.post<EmployeeApiResponse>(
      `${environment.BASE_URL}employee`,
      body
    );
  }

  updateEmployee$(
    data: EmployeeDto & { id: string }
  ): Observable<EmployeeApiResponse> {
    const { id, ...employee } = data;

    const lastNamePrefix =
      typeof employee.lastNamePrefix === "string"
        ? employee.lastNamePrefix.trim()
        : null;

    const body: EmployeeDto = {
      ...employee,
      firstName: employee.firstName.trim(),
      lastName: employee.lastName.trim(),
      phoneNumber: employee.phoneNumber.trim(),
      email: employee.email.trim().toLowerCase(),
      userName: employee.userName.trim().toLowerCase(),
      lastNamePrefix: lastNamePrefix || null,
    };

    return this.http.put<EmployeeApiResponse>(
      `${environment.BASE_URL}employee/${id}`,
      body
    );
  }

  activateEmployee$(id: string): Observable<EmployeeApiResponse> {
    return this.http.post<EmployeeApiResponse>(
      `${environment.BASE_URL}employee/activate/${id}`,
      {}
    );
  }

  deactivateEmployee$(id: string): Observable<EmployeeApiResponse> {
    return this.http.post<EmployeeApiResponse>(
      `${environment.BASE_URL}employee/deactivate/${id}`,
      {}
    );
  }

  resendConfirmation$(id: string): Observable<EmployeeApiResponse> {
    return this.http.post<EmployeeApiResponse>(
      `${environment.BASE_URL}employee/resendConfirmation/${id}`,
      {}
    );
  }
}
